import { render, staticRenderFns } from "./importConfigComs.vue?vue&type=template&id=18347c5c&"
import script from "./importConfigComs.vue?vue&type=script&lang=js&"
export * from "./importConfigComs.vue?vue&type=script&lang=js&"
import style0 from "./importConfigComs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports